import { Translatable } from "@icc/shared/helpers";
import { Units } from "@icc/shared/helpers";

/** Zaslepka/zatyczka prowadnic */
export class GuideCap {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    img: string;
    default: boolean;
    changed: boolean;
    profiles: number[];
    colorGroupSetId: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;

    /** Jedna zatyczka na prowadnicę */
    singlePerGuide?: boolean;

    unitCode: Units.PCS | Units.PAIR;

    printCode: string;
}

export interface IccGuideCap {
    id: number;
    /** Kod zewnętrzny */
    extId?: string;
    /** Kod do indeksu */
    indexNo?: string;
    name: string;
    img: string;
    profiles: number[];
    colorGroupSetId: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
    /** Jedna zatyczka na prowadnicę */
    singlePerGuide?: boolean;

    unitCode: Units.PCS | Units.PAIR;

    printCode: string;
}
